export default __webpack_public_path__ + "static/media/info-b.db663cbb.svg";